import { AuthorizedContent } from '@frontegg/react';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDashboardMode } from '../../../contexts/dashboardModeContext';
import ExportType from '../../../utils/enum/ExportType';
import RolesType from '../../../utils/enum/RolesType';
import ShareButton from '../../ShareButton/shareButton';
import Title from '../../Title/title';
import DashboardDropdown from '../DashboardDropdown/dashboardDropdown';
import {
    ClauseFilterProps,
    DateRangeScopeProps,
    ScopeProps,
} from '../dashboardInterfaces';
import ExportDropdown from '../ExportDropdown/exportDropdown';
import DashboardHeaderStyled, { ButtonContainer, ModeToggleButton, ModeToggleContainer, NoPrintWrapper } from './styled';

interface DashboardHeaderProps {
    name: string
    selectedClauseFilter: Array<ClauseFilterProps>
    selectedScope: Array<ScopeProps>
    selectedDateRange: DateRangeScopeProps | null
    surveyId: string
}

const DashboardHeader: FC<DashboardHeaderProps> = ({ name, selectedClauseFilter, selectedScope, selectedDateRange, surveyId }) => {
    const { isCreationMode, setIsCreationMode } = useDashboardMode();
    const { t } = useTranslation('dashboard');

    return (
        <DashboardHeaderStyled>
            <Title content={name} />
            <ButtonContainer>
                <AuthorizedContent requiredRoles={[RolesType.ADMIN, RolesType.ADMIN_MOAI]}>
                    <ModeToggleContainer>
                        <ModeToggleButton $active={!isCreationMode} onClick={() => setIsCreationMode(false)}>
                            {t('previewMode')}
                        </ModeToggleButton>
                        <ModeToggleButton $active={isCreationMode} onClick={() => setIsCreationMode(true)}>
                            {t('creationMode')}
                        </ModeToggleButton>
                    </ModeToggleContainer>
                </AuthorizedContent>
                <DashboardDropdown />
                <NoPrintWrapper>
                    <ExportDropdown exportCase={ExportType.ANSWERS} horizontal='left' selectedClauseFilter={selectedClauseFilter} selectedDateRange={selectedDateRange} selectedScope={selectedScope} surveyId={surveyId} vertical='bottom' exportPdf />
                </NoPrintWrapper>
                <AuthorizedContent requiredRoles={[RolesType.ADMIN, RolesType.ADMIN_MOAI]}>
                    <NoPrintWrapper>
                        <ShareButton />
                    </NoPrintWrapper>
                </AuthorizedContent>
            </ButtonContainer>
        </DashboardHeaderStyled>
    );
};

export default DashboardHeader;
